import { useContext, useEffect, useState } from "react";
import { ICandidateProfile } from "../../domain/candidate";
import { SortResult } from "../../components/rank-sort/types";
import { ApiContext } from "../../context/api.provider";
import { ELECTION_STATUS, IElectionRound, ISubmitStateMap, VOTING_ROUND_STATUS } from "../../domain/election";
import { IVoter } from "../../domain/voter";
import { INTERFACE_STATE } from "./election.context";

export const useCandidates = (question_id: string) => {
    const { fetch } = useContext(ApiContext);
    const [candidates, setCandidates] = useState<ICandidateProfile[] | null>(null);

    useEffect(() => {
        if (fetch) {
            fetch({ method: 'get', url: `/questions/${question_id}/candidates` }).then(r => setCandidates(r.data));
        }
    }, [fetch, question_id])

    return candidates
}


export const sortResult = (a: SortResult, b: SortResult) => {
    if (a.index === null)
        return 1;
    if (b.index === null)
        return -1;
    return a.index > b.index ? 1 : -1
}

export const formateDate = (date: Date | string) => {
    date = new Date(date);
    return date.toDateString();
}

export const sortDisplayOrder = (
    a: { display_order?: number | null | undefined },
    b: { display_order?: number | null | undefined }) => {
    if (a.display_order === undefined || a.display_order === null)
        return 0;
    if (b.display_order === undefined || b.display_order === null)
        return 0;
    if (a.display_order === b.display_order)
        return 0;

    return a.display_order > b.display_order ? 1 : -1
}


const allPagesSubmitted = (ballotStatus?: ISubmitStateMap) => {
    if (!ballotStatus) {
        return false;
    }
    for (const page of Object.values(ballotStatus)) {
        if (!page.self_submitted) {
            return false;
        }
    }
    return true;
}

export const computeInterfaceStatus = (election?: IElectionRound, voter?: IVoter, submitStateMap?: ISubmitStateMap) => {

    if (!voter || !election) {
        // not ready
        return INTERFACE_STATE.LOADING;
    }

    if (election.election_status === ELECTION_STATUS.COMPLETE) {
        return INTERFACE_STATE.ELECTION_ALREADY_CLOSED;
    }

    switch (election.status) {
        case VOTING_ROUND_STATUS.VOTING:
            const allSubmitted = allPagesSubmitted(submitStateMap)

            if (allSubmitted) {
                return INTERFACE_STATE.ALREADY_SUBMITTED;
            }
            else {
                return INTERFACE_STATE.VOTING_ALLOWED;
            }
        case VOTING_ROUND_STATUS.NOMINATIONS:
        case VOTING_ROUND_STATUS.DRAFT:
            return INTERFACE_STATE.ELECTION_NOT_YET_OPEN;
        case VOTING_ROUND_STATUS.CLOSED:
            return INTERFACE_STATE.ELECTION_ALREADY_CLOSED;
    }

    throw new Error("Unexpected election state")

}


export const createSubmitStateMap = (election: IElectionRound, submitStateMap?: ISubmitStateMap) => {
    const _submitStateMap = {
        ...submitStateMap,
    };
    for (const ballot of election.ballots) {
        if (!_submitStateMap[ballot.id]) {
            _submitStateMap[ballot.id] = {
                self_submitted: false,
                proxy_submitted: null,
            };
        }
    }
    return _submitStateMap;
}